/**
 * Where the ports and cities on Xtellar's lanes are, for a route that names a
 * place without coordinates. Its own module, free of app imports, so the 3D
 * terminal's layout (and the root test suite) can use it without the rest of
 * the sea-route helpers.
 */
export const knownRouteCoordinates = [
  { patterns: ['shekou', 'shenzhen', 'cnshe', 'cnszx'], latitude: 22.49, longitude: 113.91 },
  { patterns: ['nanhai', 'nansha', 'cnnah'], latitude: 23.0167, longitude: 113.15 },
  { patterns: ['ningbo', 'cnngb'], latitude: 29.87, longitude: 121.55 },
  { patterns: ['shanghai', 'cnsha'], latitude: 31.23, longitude: 121.47 },
  { patterns: ['xiamen', 'cnxmn'], latitude: 24.48, longitude: 118.09 },
  { patterns: ['guangzhou', 'cancan'], latitude: 23.13, longitude: 113.26 },
  { patterns: ['singapore', 'sgsin'], latitude: 1.29, longitude: 103.85 },
  { patterns: ['port klang', 'mypkg'], latitude: 3.0, longitude: 101.4 },
  { patterns: ['colombo', 'lkcmb'], latitude: 6.93, longitude: 79.84 },
  { patterns: ['mombasa', 'kemba'], latitude: -4.04, longitude: 39.67 },
  { patterns: ['dar es salaam', 'tzdar'], latitude: -6.82, longitude: 39.28 },
  { patterns: ['kampala', 'uganda', 'ugkla'], latitude: 0.35, longitude: 32.58 },
]
